import { Form } from "antd";
import { useForm } from "antd/es/form/Form";

import { PageTitle } from "../../components/AppLayout/components/Content/components";
import {
    Autocomplete,
    Checkbox,
    DynamicProperties,
    FileContents,
    MultiSelectDynamic,
    SelectDynamic,
    TextInput,
    TextTemplating,
    TimePicker,
    UploadFile,
} from "../../components/Form/formComponents";
import { AcquirersContractsTable } from "../../components/Form/formComponents/AcquirersContractsTable/AcquirersContractsTable";
import { DatePickerInput } from "../../components/Form/formComponents/DatePicker/DatePicker";
import { InputGenerator } from "../../components/Form/formComponents/InputGenerator/InputGenerator";
import { NumberInput } from "../../components/Form/formComponents/Number/NumberInput";
import { SiteIdCopyGenerator } from "../../components/Form/formComponents/SiteIdGenerator/SiteIdCopyGenerator";
import { SiteIdGenerator } from "../../components/Form/formComponents/SiteIdGenerator/SiteIdGenerator";
import { TerminalIdCopyGenerator } from "../../components/Form/formComponents/TerminalIdGenerator/TerminalIdCopyGenerator";
import { TerminalIdGenerator } from "../../components/Form/formComponents/TerminalIdGenerator/TerminalIdGenerator";
import {
    FormFieldLabelStyle,
    HorizontalFormFieldStyle,
    VerticalFormFieldStyle,
} from "../../components/Form/formFieldLabelPositioning/styles/FormFieldsStyle";
import { FormComponent, ValidationType } from "../../components/Form/types/types";
import { InlineFormFieldStyle } from "../../components/SearchForm/styles/SearchFormFieldsStyle";
import { TextareaInputStyle } from "../styles/InputStyle";

export const FormFieldDocs = () => {
    const [form] = useForm();
    return (
        <>
            <PageTitle translationKey="Generic Form Fields" />
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Text Input</FormFieldLabelStyle>
                    <TextInput label="test" name="name" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Autocomplete</FormFieldLabelStyle>
                    <Autocomplete label="test" readOnly={false} datasource="tet" displayValue="yes" />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>checkbox</FormFieldLabelStyle>
                    <Checkbox name="test" readOnly={false} label={" "} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>DatePicker</FormFieldLabelStyle>
                    <DatePickerInput name="test" readOnly={false} type="date" format="YYYY-MM-dd'T'HHmmss.SSS+Z" />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>File Contents</FormFieldLabelStyle>
                    <FileContents name="test" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Input Generator</FormFieldLabelStyle>
                    <InputGenerator name="test" label="" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Dynamic Multi Select</FormFieldLabelStyle>
                    <MultiSelectDynamic
                        name="test"
                        label=""
                        readOnly={false}
                        fieldConfig={{
                            name: "services",
                            component: FormComponent.MULTI_SELECT_DYNAMIC,
                            urlToFetchOptions: "/configurations/acquirer-services-modes",
                            optionDisplayPropName: "key",
                            optionValuePropName: "value",
                            attributes: {},
                            translationKeys: {
                                label: "acquirerCreateForm.services",
                            },
                        }}
                    />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Number</FormFieldLabelStyle>
                    <NumberInput name="test" label="" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Select dynamic</FormFieldLabelStyle>
                    <SelectDynamic
                        name="test"
                        label=""
                        readOnly={false}
                        fieldConfig={{
                            name: "siteId",
                            component: FormComponent.SELECT_DYNAMIC,
                            urlToFetchOptions: "/configurations/site-id",
                            optionDisplayPropName: "key",
                            optionValuePropName: "value",
                            attributes: {
                                validationRules: [
                                    {
                                        name: ValidationType.VALIDATION_REQUIRED,
                                    },
                                ],
                            },
                            translationKeys: {
                                label: "contractCreateForm.site",
                            },
                        }}
                    />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>SiteId Copy Generator</FormFieldLabelStyle>

                    <SiteIdCopyGenerator name="test" label="" readOnly={false} siteId="test" />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>SiteId Generator</FormFieldLabelStyle>

                    <SiteIdGenerator name="test" label="" readOnly={false} siteGroupId={1000} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>TerminalId Copy Generator</FormFieldLabelStyle>

                    <TerminalIdCopyGenerator name="test" label="" readOnly={false} terminalId={1000} orgUnitId={1000} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>TerminalId Generator</FormFieldLabelStyle>

                    <TerminalIdGenerator name="test" label="" readOnly={false} terminalProfileId={1000} siteId={1000} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Text Area</FormFieldLabelStyle>

                    <TextareaInputStyle name="test" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Text Templating</FormFieldLabelStyle>

                    <TextTemplating name="test" label="" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Time Picker</FormFieldLabelStyle>

                    <TimePicker name="test" label="" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Upload Input</FormFieldLabelStyle>

                    <UploadFile name="test" label="" readOnly={false} />
                </HorizontalFormFieldStyle>
            </p>
            <p>
                <HorizontalFormFieldStyle>
                    <FormFieldLabelStyle>Dynamic properties</FormFieldLabelStyle>
                    <DynamicProperties label="test" readOnly={false} useReadOnly={false} />
                </HorizontalFormFieldStyle>
            </p>

            <PageTitle translationKey="Search Form Fields" />

            <InlineFormFieldStyle>
                <Form form={form}>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Text input</FormFieldLabelStyle>
                            <TextInput label="test" name="name" readOnly={false} />
                        </VerticalFormFieldStyle>
                    </p>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Checkbox</FormFieldLabelStyle>
                            <Checkbox label="test" name="name" readOnly={false} />
                        </VerticalFormFieldStyle>
                    </p>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Date Picker</FormFieldLabelStyle>
                            <Form.Item>
                                <DatePickerInput name="test" readOnly={false} type="date" format="YYYY-MM-dd'T'HHmmss.SSS+Z" />
                            </Form.Item>
                        </VerticalFormFieldStyle>
                    </p>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Number</FormFieldLabelStyle>
                            <NumberInput label="test" name="name" readOnly={false} />
                        </VerticalFormFieldStyle>
                    </p>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Select Dynamic</FormFieldLabelStyle>
                            <SelectDynamic
                                name="test"
                                label=""
                                readOnly={false}
                                fieldConfig={{
                                    name: "siteId",
                                    component: FormComponent.SELECT_DYNAMIC,
                                    urlToFetchOptions: "/configurations/site-id",
                                    optionDisplayPropName: "key",
                                    optionValuePropName: "value",
                                    attributes: {
                                        validationRules: [
                                            {
                                                name: ValidationType.VALIDATION_REQUIRED,
                                            },
                                        ],
                                    },
                                    translationKeys: {
                                        label: "contractCreateForm.site",
                                    },
                                }}
                            />
                        </VerticalFormFieldStyle>
                    </p>
                    <p>
                        <VerticalFormFieldStyle>
                            <FormFieldLabelStyle>Time picker</FormFieldLabelStyle>
                            <TimePicker name="test" label="" readOnly={false} />
                        </VerticalFormFieldStyle>
                    </p>
                </Form>
            </InlineFormFieldStyle>

            <PageTitle translationKey="Form Table Field" />
            <p>
                <VerticalFormFieldStyle>
                    <FormFieldLabelStyle>Acquirers Contracts Table</FormFieldLabelStyle>
                    <AcquirersContractsTable readOnly={false} />
                </VerticalFormFieldStyle>
            </p>
        </>
    );
};
